export const showToast = (message) => {
  window.dispatchEvent(new CustomEvent("app:toast", { detail: String(message) }));
};

export const confirmToast = (message) => new Promise((resolve) => {
  window.dispatchEvent(new CustomEvent("app:confirm-toast", {
    detail: { message: String(message), resolve }
  }));
});
